<template>
  <div class="printingPage self-help">
    <div class="content">
      <div class="dragUpload" v-if="showUploadDragCompontent">
        <BreadCrumb />
        <uploadDrag
          v-if="showUploadDragCompontent"
          @dragleaveFn="dragleaveFn"
          @successFile="successFile"
          ref="dragUpload"
          @showUploadDragCompontentFn="showUploadDragCompontentFn"
        ></uploadDrag>
      </div>
      <div
        class="content-box"
        v-if="
          empty === 'really' &&
            !showUploadDragCompontent &&
            !isUploading &&
            !order
        "
      >
        <BreadCrumb />
        <div class="box">
          <div
            class="uploadButton"
            @click="showUploadPopupFn"
            @dragenter="dragenterFn"
          >
            <img src="@/assets/img/printingPage/addfile.png" alt="" />
            <span>添加打印文件</span>
          </div>
          <PrintList
            :isLoadingPrintList="isLoadingPrintList"
            :tableData="tableData"
            @refresh="Refresh"
            @clearInterval="clearInterval"
          />
        </div>
      </div>
      <div class="content-box" v-if="isUploading">
        <BreadCrumb />
        <div class="box">
          <div
            class="uploadButton"
            @click="showUploadPopupFn"
            @dragenter="dragenterFn"
          >
            <img src="@/assets/img/printingPage/addfile.png" alt="" />
            <span>添加打印文件</span>
          </div>
          <div class="tableTitle uploadTitle">文件列表</div>
          <div>
            <UploadList
              @togglePrintOptions="togglePrintOptions"
              :uploadLists="uploadLists"
              @removeFile="removeFile"
            />
          </div>
        </div>
      </div>
      <div class="content-box" v-if="order">
        <BreadCrumb />
        <div class="box">
          <div>
            <OrderList @updatePrintingList="updatePrintingList" />
          </div>
        </div>
      </div>
      <div
        class="content-box"
        v-else-if="
          (empty === 'false' &&
            !showUploadDragCompontent &&
            !isUploading &&
            !order) ||
            !isLogin
        "
      >
        <BreadCrumb />
        <div class="emptyBox">
          <Empty @showUploadPopupFn="showUploadPopupFn" />
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <Choice
      v-if="isLogin"
      :showCurrency.sync="showCurrency"
      :currencyParams="currencyParams"
      @successFile="successFile"
      @cloudDocument="cloudDocument"
      @mobile="mobile"
      ref="localUpload"
    ></Choice>
    <printOptions
      v-if="showPrintOptions"
      :singleConvertInfo="singleConvertInfo"
      :downloadUrl="downloadUrl"
      :printOptions.sync="showPrintOptions"
      @clearPrintProps="clearPrintProps"
      @updatePrintingList="updatePrintingList"
      @update:printOptions="closePrintOptions"
    ></printOptions>
    <cloudDocument
      v-if="showCloudDocument"
      :showCloudDocument.sync="showCloudDocument"
      @cloudDocumentUpload="cloudDocumentUpload"
    ></cloudDocument>
    <el-dialog
      :visible.sync="secureListModal"
      width="400px"
      top="25vh"
      :center="true"
    >
      <div class="tipsContainer">
        <img
          class="tipsImg"
          :src="require('img/printingPage/printer.png')"
          alt=""
        />
        <h3>扫码打印已开启</h3>
        <p>
          文件已加入打印队列，请在24小时内走到打印机前扫描快印码，开始打印。
        </p>
        <el-button
          class="confirmBtn"
          type="primary"
          @click="secureListModal = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import { mapMutations, mapState } from "vuex";
import { getPrintingList, cancelPrinting, getEquipmentList } from "api/api";
import { REQUEST_URL } from "const";
import Bus from "@/utils/bus";
import Choice from "cpnts/web/Print/choice/choice";
import printOptions from "cpnts/web/Print/printOptions/printOptions";
import UploadList from "cpnts/web/UploadLists.vue";
import cloudDocument from "cpnts/web/Print/cloudDocument/cloudDocument";
import uploadDrag from "cpnts/web/Print/upload/upload";
import BreadCrumb from "cpnts/web/BreadCrumb.vue";
import uploadMixin from "mixins/upload.js";
import OrderList from "./components/OrderList.vue";
import Empty from "./components/Empty.vue";
import PrintList from "./components/PrintList.vue";
import { signIn } from "../../../utils/utils";
export default {
  name: "printingPage",
  components: {
    Choice,
    printOptions,
    cloudDocument,
    uploadDrag,
    BreadCrumb,
    UploadList,
    OrderList,
    Empty,
    PrintList
  },
  mixins: [uploadMixin],
  data() {
    return {
      isLogin:
        localStorage.getItem("token") ||
        localStorage.getItem("loginType") === "iam",
      empty: null, //是否为空
      showCurrency: false, //弹窗展示
      showPrintOptions: false, //打印选项弹窗
      secureListModal: false, // 安全打印提示弹窗
      showCloudDocument: false, //云文档弹窗
      showUploadDragCompontent: false, //是否拖拽进入
      isLoadingPrintList: false, //loading
      currencyParams: {
        title: "",
        type: ""
      }, //弹窗展示参数
      inputValue: "", //输入搜索的值
      select: "fileName",
      tableData: [], //打印队列
      timer: null, //轮询定时器
      singleConvertInfo: null, // 单文件打印时传targetid 优化接口处理逻辑
      downloadUrl: null // 预览地址
    };
  },
  computed: {
    ...mapState("batch", ["isUploading", "order"])
  },
  metaInfo() {
    return {
      title: "自助打印_福昕智慧打印",
      meta: [
        {
          // set meta
          name: "description",
          content:
            "福昕智慧打印是一款免费的打印机共享软件，包含远程打印、手机打印、共享打印、云打印等功能，满足企业内员工电脑自助打印、手机自助打印、远程自助打印等多场景自助打印需求"
        },
        {
          name: "keywords",
          content:
            "电脑自助打印、手机自助打印、远程自助打印、免费共享打印机、微信打印、手机打印、电脑打印、福昕智慧打印、云打印、免费打印、共享打印、自助打印软件"
        }
      ]
    };
  },
  methods: {
    ...mapMutations("batch", ["SET_UPLOAD_LISTS", "SET_ORDER"]),
    // 显示打印参数设置并传参
    togglePrintOptions(convertInfo, downloadUrl) {
      this.showPrintOptions = true;
      this.singleConvertInfo = convertInfo;
      this.downloadUrl = downloadUrl;
    },
    clearPrintProps() {
      this.singleConvertInfo = null;
      this.downloadUrl = null;
    },
    init() {
      this.getPrintingListFn(); //打印列表
      getEquipmentList().then(res => {
        const { code, data = [] } = res;
        sessionStorage.setItem("equipmentList", JSON.stringify(data));
      });
    },
    removeFile(uid) {
      // 中断上传或者取消打印
      this.$refs.dragUpload && this.$refs.dragUpload.removeFile(uid);
      this.$refs.localUpload && this.$refs.localUpload.removeFile(uid);
    },
    clearInterval() {
      clearInterval(this.timer);
    },
    //获取打印列表\刷新
    getPrintingListFn(config) {
      clearInterval(this.timer);
      getPrintingList(config)
        .then(res => {
          const { code, data } = res;
          if (code === 0) {
            if (data) {
              this.empty = "really"; //显示列表
              this.isLoadingPrintList = false; //关闭loading
              this.tableData = data;
              //打印队列排列
              let map = new Map();
              for (let item of data) {
                if (item.status === "0") {
                  let list = map.get(item.equipmentId);
                  if (!list) {
                    list = [];
                    map.set(item.equipmentId, list);
                  }
                  list.push(item.id);
                }
              }
              for (let item of data) {
                if (item.status === "0") {
                  let list = map.get(item.equipmentId);
                  let id = item.id;
                  let index = list.indexOf(id) + 1;
                  let title = index + "/" + list.length;
                  item.show = title;
                }
              }
              //轮询
              const config = {
                showLoading: false
              };
              if (!data) {
                clearInterval(this.timer);
              } else {
                if (this.$route.name !== "index") return;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                  this.isLoadingPrintList = true;
                  this.getPrintingListFn(config);
                }, 5000);
              }
            } else {
              clearInterval(this.timer);
              this.isLoadingPrintList = false;
              this.empty = "false";
            }
          }
        })
        .catch();
    },
    //刷新
    Refresh() {
      this.$store.commit("request/UPDATE_ADD_REQUEST_COUNT");
      setTimeout(() => {
        this.$store.commit("request/UPDATE_SUBTRACT_REQUEST_COUNT");
      }, 1000);
      this.getPrintingListFn();
    },
    /**
     * [signIn 登录]
     *
     * @return  {[type]}  [return description]
     */
    signIn() {
      signIn();
    },

    getList() {
      getEquipmentList().then(res => {
        const { code, data = [] } = res;
        if (code === 0) {
          if (data.length) {
            this.showCurrency = true;
            this.currencyParams = {
              title: "添加打印文件",
              type: "printing"
            };
          } else {
            this.$alert({
              description: "暂无可使用的打印机，请先添加打印机"
            });
          }
          sessionStorage.setItem("equipmentList", JSON.stringify(data));
        }
      });
    },

    //添加打印文件弹窗
    showUploadPopupFn() {
      if (!this.isLogin) {
        return this.signIn();
      }
      this.getList();
    },
    //拖拽进入
    dragenterFn() {
      this.showUploadDragCompontent = true;
    },
    //拖拽离开
    dragleaveFn() {
      this.showUploadDragCompontent = false;
    },
    //下拉搜索隐藏失去焦点（IE下）
    inputBlur(flag, refName) {
      // 隐藏下拉时失去焦点（针对ie）
      this.$refs[refName].$children[0].blur();
    },
    //接收子组件传值
    successFile(data) {
      this.showPrintOptions = data;
    },
    //接收选择云文档弹窗传值
    cloudDocumentUpload(data) {
      this.showPrintOptions = data;
    },
    //手机打印
    mobile() {
      this.currencyParams = {
        title: "手机打印",
        type: "mobile"
      };
    },
    showUploadDragCompontentFn() {
      this.showUploadDragCompontent = false;
    },
    //云文档弹窗
    cloudDocument(data) {
      this.showCloudDocument = data;
    },
    //接收打印选项弹窗
    updatePrintingList(type) {
      this.showPrintOptions = false; //关闭打印选项弹窗
      this.$message({
        message: "创建成功",
        duration: 2000,
        customClass: "messageTip",
        type: "success"
      });
      this.getPrintingListFn(); //列表更新
      if (type === "secure") {
        // 展示安全打印提示弹窗
        this.secureListModal = true;
      }
    },
    //关闭打印选项弹窗
    closePrintOptions() {
      this.showPrintOptions = false; //关闭打印选项弹窗
    }
  },
  mounted() {
    if (
      localStorage.getItem("token") ||
      localStorage.getItem("loginType") === "iam"
    )
      this.init();
  },
  created() {
    //接收数据
    Bus.$off("table");
    Bus.$on("table", () => {
      this.$refs.table.doLayout();
    });
  },
  beforeDestroy() {
    this.SET_UPLOAD_LISTS([]);
    this.SET_ORDER(null);
    this.SET_IS_UPLOADING(false);
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
.tipsContainer {
  margin: 0 auto;
  width: 266px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .tipsImg {
    width: 60px;
    margin-bottom: 18px;
  }
  h3 {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #333333;
    line-height: 13px;
    margin-bottom: 15px;
  }
  p {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #999999;
    margin-bottom: 16px;
    text-align: center;
  }
  .confirmBtn {
    width: 70px;
    height: 32px;
    border-radius: 2px;
    padding: 0;
  }
}

.self-help {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .content {
    width: 100%;
    min-height: calc(100% - 60px);
    background-color: #ffffff;
    border-radius: 4px;
    position: relative;
    .dragUpload {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .content-box {
      height: 100%;
      width: 100%;
      // min-height: 630px;
      background-color: #ffffff;
      .top {
        height: 63px;
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
      }
    }
    .box {
      padding: 30px 30px 0 30px;
      ::v-deep {
        .el-table__header {
          width: 100% !important;
        }
        .el-table__body {
          width: 100% !important;
        }
      }
      .uploadButton {
        width: 100%;
        height: 80px;
        background-color: #f8fbfe;
        border-radius: 4px;
        border: dashed 1px $theme-color;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $theme-color;
        cursor: pointer;
        img {
          margin: 0 10px 0 0;
          width: 20px;
          height: 20px;
        }
      }
      .uploadTitle {
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        letter-spacing: 0px;
        color: #212121;
      }
    }
    .inLine {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #32d600;
      margin: 0 4px 0 0;
    }
    .printNow {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: $theme-color;
      margin: 0 4px 0 0;
    }
    .printSuccess {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #32d600;
      margin: 0 4px 0 0;
    }
    .printError {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #f44141;
      margin: 0 4px 0 0;
    }
    .statusRow {
      display: flex;
      align-items: center;
    }
  }
}
.top {
  height: 63px;
  display: flex;
  align-items: center;
  background-color: #f8f8f8;
}

.emptyBox {
  width: 100%;
  padding-left: 60px;
  padding-top: 26px;
}
</style>
